<template>
	<v-container align-center justify-center fill-height class="primary ma-0 fullscreen">
		<v-layout column align-center justify-center fill-height>
			<v-flex xs12 sm8 md6 lg3 xl3>
				<v-layout v-if="debugMode" align-center class="orange darken-1 mb-2">
					<v-icon class="ml-2">mdi-alert</v-icon>
					<span class="ml-2">DEBUG mode</span>
					<v-spacer />
					<dialog-debug />
				</v-layout>

				<v-progress-circular indeterminate color="primary" v-if="isAutologinPending" />

				<v-card class="pa-4" v-else>
					<v-card-title>
						<v-layout justify-center>
							<img src="@/assets/logo.png" height="64" />
						</v-layout>
					</v-card-title>
					<v-form ref="form" v-if="useLoginCredentials" v-model="valid" lazy-validation @submit="submit">
						<v-text-field
							autofocus
							type="text"
							name="username"
							browser-autocomplete="username"
							autocorrect="off"
							autocapitalize="none"
							placeholder=""
							required
							:label="$t('LOGIN_USERNAME_LABEL')"
							:rules="[rules.required]"
							v-model="username" />

						<v-text-field
							type="password"
							name="password"
							browser-autocomplete="password"
							required
							:label="$t('LOGIN_PASSWORD_LABEL')"
							:rules="[rules.required]"
							v-model="password" />
						
						<v-alert
							class="pa-2 mb-3"
							outline
							dismissible
							type="error"
							transition="scale-transition"
							:value="!!authCredentialsError"
							@input="clearAuthCredentialsError">

							{{ authCredentialsError }}
						</v-alert>

						<v-btn
							block
							color="primary"
							type="submit"
							:disabled="!valid"
							:loading="isLoginWithCredentialsPending">
							
							{{ $t('LOGIN_SUBMIT_TEXT') }}
						</v-btn>
					</v-form>
					<v-divider class="mt-4" v-if="useLoginSSO && useLoginCredentials" />
					<template v-if="useLoginSSO">
						<v-alert
							class="pa-2 mb-3"
							outline
							dismissible
							type="error"
							transition="scale-transition"
							:value="!!authSSOError" 
							@input="clearAuthSSOError">
							{{ authSSOError }}
						</v-alert>

						<v-btn
							class="mt-4"
							block
							color="primary"
							:href="ssoURLWithParams"
							:loading="isAuthenticatePending">
						
							{{ $t('LOGIN_WITH_FORUM_TEXT') }}
						</v-btn>
					</template>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>


<script>
import { mapState } from 'vuex';
import DialogDebug from '@/dialogs/DialogDebug';

export default {
	name: "login-pane",
	components: { DialogDebug },
	data(self) { return {
		username: null,
		password: null,
		valid: false,
		isLoginWithCredentialsPending: false,
		rules: {
			required(value) {
				return !!value || self.$t('GENERAL_VALIDATION_ERROR_REQUIRED');
			},
		},
	}},
	computed: {
		...mapState(['i18n', 'debugMode']),
		...mapState('auth', [
			'isAutologinPending',
			'isAuthenticatePending',
			// login with SSO
			'useLoginSSO',
			'ssoURL',
			'authSSOError',
			// login with credentials
			'useLoginCredentials',
			'authCredentialsError',
		]),
		ssoURLWithParams() {
			const url = this.ssoURL;
			return this.debugMode ? `${url}?debug=true` : url;
		},
	},
	methods: {
		clearAuthSSOError() {
			this.$store.commit('auth/setAuthSSOError', null);
		},
		clearAuthCredentialsError() {
			this.$store.commit('auth/setAuthCredentialsError', null);
		},

		async submit(e) {
			e.preventDefault();

			const { valid, username, password } = this;
			if (valid) {
				this.isLoginWithCredentialsPending = true;
				await this.$store.dispatch('auth/login', { username, password });
				this.isLoginWithCredentialsPending = false;
			}

			return false;
		},
	},
};
</script>

<style scoped lang="less">
	.fullscreen {
		width: 100%;
		max-width: none !important;
	}
</style>
